import React from 'react';
import PropTypes from 'prop-types';

import { hotelsShape } from 'constants/propTypes';
import ConfirmCancellationCta from './ConfirmCancellationCta';
import RevertChangeCta from './RevertChangeCta';

import { StyledButtonRow } from './RefundsActions.styles';

const RefundsActions = ({
  reference,
  allowPointsWriteOff,
  label,
  defaultRoute,
  ctaRoute,
  markPaymentAsProcessed,
  skipBookingConfirmation,
  totalPoints,
  milesUsed,
  membershipNumber,
  currency,
  handleSubmit,
  cancelHotelInJacTravel,
  hotels,
  userTierBenefitUpgrades,
  userBusinessBenefitUpgrades
}) => (
  <StyledButtonRow>
    <ConfirmCancellationCta
      allowPointsWriteOff={allowPointsWriteOff}
      skipConfirmation={skipBookingConfirmation}
      bookingReference={reference}
      label={label}
      nextRoute={ctaRoute}
      errorCTARedirect={defaultRoute}
      markPaymentAsProcessed={markPaymentAsProcessed}
      totalPoints={totalPoints}
      milesUsed={milesUsed}
      membershipNumber={membershipNumber}
      currency={currency}
      handleSubmit={handleSubmit}
      cancelHotelInJacTravel={cancelHotelInJacTravel}
      hotels={hotels}
      userTierBenefitUpgrades={userTierBenefitUpgrades}
      userBusinessBenefitUpgrades={userBusinessBenefitUpgrades}
    />
    <RevertChangeCta bookingReference={reference} nextRoute={defaultRoute} />
  </StyledButtonRow>
);

RefundsActions.propTypes = {
  allowPointsWriteOff: PropTypes.bool,
  skipBookingConfirmation: PropTypes.bool.isRequired,
  reference: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  defaultRoute: PropTypes.string.isRequired,
  ctaRoute: PropTypes.string,
  markPaymentAsProcessed: PropTypes.bool.isRequired,
  currency: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  cancelHotelInJacTravel: PropTypes.bool,
  totalPoints: PropTypes.number,
  milesUsed: PropTypes.number,
  membershipNumber: PropTypes.string,
  hotels: hotelsShape,
  userTierBenefitUpgrades: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      benefitStatus: PropTypes.string,
      benefitName: PropTypes.string,
      transactionJournal: PropTypes.string,
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      cancellationReason: PropTypes.oneOfType([PropTypes.string, PropTypes.objectOf(null)]),
      bookingReference: PropTypes.string,
      benefitRedemptionDate: PropTypes.string
    })
  ),
  userBusinessBenefitUpgrades: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      benefitStatus: PropTypes.string,
      benefitName: PropTypes.string,
      benefitTypeName: PropTypes.string,
      transactionJournal: PropTypes.string,
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      reasonForCancellation: PropTypes.oneOfType([PropTypes.string, PropTypes.objectOf(null)]),
      pnr: PropTypes.string,
      benefitRedemptionDate: PropTypes.string
    })
  )
};

export default RefundsActions;
